"use strict";
// ============================================================
// GraphicSIMS / NewBlue Enterprise — Shared Constants
// ============================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.PORTS = exports.INPUT_URLS = exports.SWITCHERSIM = exports.ROOM = exports.TIMING = exports.SCORING = exports.SCOREBOARD_ENTERPRISE_LESSON_REGISTRY = exports.SCOREBOARD_ENTERPRISE_LESSON_IDS = exports.ENTERPRISE_LESSON_REGISTRY = exports.LESSON_REGISTRY = exports.QUIZ_LESSON_IDS = exports.ENTERPRISE_LESSON_IDS = exports.MULTIPLAYER_LESSON_IDS = exports.CAPSTONE_LESSON_IDS = exports.CORE_LESSON_IDS = exports.SIM_ACCESS = exports.ROLE_HIERARCHY = exports.FEATURES_BY_ROLE = void 0;
const shared_types_1 = require("@graphicsim/shared-types");
// --- RBAC Feature Matrix ---
exports.FEATURES_BY_ROLE = {
    [shared_types_1.UserRole.STUDENT]: {
        lessons: true,
        capstones: true,
        multiplayer: true,
        quizzes: true,
        readings: true,
        sandbox: false,
        gradebook: true,
        pacingControls: false,
    },
    [shared_types_1.UserRole.ENTERPRISE]: {
        lessons: true,
        capstones: false,
        multiplayer: false,
        quizzes: false,
        readings: false,
        sandbox: true,
        gradebook: false,
        pacingControls: false,
    },
    [shared_types_1.UserRole.TEACHER]: {
        lessons: true,
        capstones: true,
        multiplayer: true,
        quizzes: true,
        readings: true,
        sandbox: false,
        gradebook: true,
        pacingControls: true,
    },
    [shared_types_1.UserRole.ADMIN]: {
        lessons: true,
        capstones: true,
        multiplayer: true,
        quizzes: true,
        readings: true,
        sandbox: true,
        gradebook: true,
        pacingControls: true,
    },
    [shared_types_1.UserRole.MANAGER]: {
        lessons: true,
        capstones: true,
        multiplayer: true,
        quizzes: true,
        readings: true,
        sandbox: true,
        gradebook: true,
        pacingControls: true,
    },
    [shared_types_1.UserRole.APPRENTICE]: {
        lessons: true,
        capstones: false,
        multiplayer: false,
        quizzes: false,
        readings: false,
        sandbox: false,
        gradebook: false,
        pacingControls: false,
    },
};
// --- Role Hierarchy (from login-v2sims) ---
exports.ROLE_HIERARCHY = {
    [shared_types_1.UserRole.ADMIN]: [shared_types_1.UserRole.ADMIN, shared_types_1.UserRole.MANAGER, shared_types_1.UserRole.TEACHER, shared_types_1.UserRole.STUDENT, shared_types_1.UserRole.ENTERPRISE, shared_types_1.UserRole.APPRENTICE],
    [shared_types_1.UserRole.MANAGER]: [shared_types_1.UserRole.TEACHER, shared_types_1.UserRole.STUDENT, shared_types_1.UserRole.ENTERPRISE, shared_types_1.UserRole.APPRENTICE],
    [shared_types_1.UserRole.TEACHER]: [shared_types_1.UserRole.STUDENT],
    [shared_types_1.UserRole.STUDENT]: [],
    [shared_types_1.UserRole.ENTERPRISE]: [],
    [shared_types_1.UserRole.APPRENTICE]: [],
};
// --- SIM Access by Subscription (GraphicSIMS = control_room only) ---
exports.SIM_ACCESS = {
    [shared_types_1.SubscriptionLevel.VIDEO_CLUB]: ['switcher'],
    [shared_types_1.SubscriptionLevel.STUDIO]: ['switcher', 'avclub'],
    [shared_types_1.SubscriptionLevel.CONTROL_ROOM]: ['switcher', 'replay', 'audio', 'director', 'avclub', 'graphics'],
};
// --- Lesson IDs ---
exports.CORE_LESSON_IDS = [
    'gfx-01', 'gfx-02', 'gfx-03', 'gfx-04', 'gfx-05', 'gfx-06',
];
exports.CAPSTONE_LESSON_IDS = [
    'cap-01', 'cap-02', 'cap-03',
];
exports.MULTIPLAYER_LESSON_IDS = [
    'multi-01', 'multi-02', 'multi-03',
];
exports.ENTERPRISE_LESSON_IDS = [
    'ent-gfx-01', 'ent-gfx-02', 'ent-gfx-03', 'ent-gfx-04', 'ent-gfx-05',
];
exports.QUIZ_LESSON_IDS = [
    'quiz-gfx-01', 'quiz-gfx-02', 'quiz-gfx-03', 'quiz-gfx-04', 'quiz-gfx-05', 'quiz-gfx-06',
];
exports.LESSON_REGISTRY = [
    // Core lessons
    { id: 'gfx-01', name: 'Understanding the NEVCO Pro Video Interface', type: shared_types_1.LessonType.CORE, unit: 1, maxScore: 100, simType: 'graphics' },
    { id: 'gfx-02', name: 'Browsing & Loading Graphics Templates', type: shared_types_1.LessonType.CORE, unit: 1, maxScore: 100, simType: 'graphics' },
    { id: 'gfx-03', name: 'Building a Project Channel', type: shared_types_1.LessonType.CORE, unit: 2, maxScore: 100, simType: 'graphics' },
    { id: 'gfx-04', name: 'Creating & Triggering Shots', type: shared_types_1.LessonType.CORE, unit: 2, maxScore: 100, simType: 'graphics' },
    { id: 'gfx-05', name: 'Data Linking & Live Updates', type: shared_types_1.LessonType.CORE, unit: 3, maxScore: 100, simType: 'graphics' },
    { id: 'gfx-06', name: 'Live Production Workflow', type: shared_types_1.LessonType.CORE, unit: 3, maxScore: 100, simType: 'graphics' },
    // Capstones
    { id: 'cap-01', name: 'Capstone: Basketball Broadcast Package', type: shared_types_1.LessonType.CAPSTONE, unit: 4, maxScore: 200, simType: 'graphics' },
    { id: 'cap-02', name: 'Capstone: Football Production', type: shared_types_1.LessonType.CAPSTONE, unit: 4, maxScore: 200, simType: 'graphics' },
    { id: 'cap-03', name: 'Capstone: Multi-Sport Challenge', type: shared_types_1.LessonType.CAPSTONE, unit: 4, maxScore: 200, simType: 'graphics' },
    // Multiplayer
    { id: 'multi-01', name: 'Multiplayer Simulation 1', type: shared_types_1.LessonType.MULTIPLAYER, unit: 5, maxScore: 100, simType: 'graphics' },
    { id: 'multi-02', name: 'Multiplayer Simulation 2', type: shared_types_1.LessonType.MULTIPLAYER, unit: 5, maxScore: 100, simType: 'graphics' },
    { id: 'multi-03', name: 'Multiplayer Simulation 3', type: shared_types_1.LessonType.MULTIPLAYER, unit: 5, maxScore: 100, simType: 'graphics' },
];
exports.ENTERPRISE_LESSON_REGISTRY = [
    { id: 'ent-gfx-01', name: 'NOVP Basics', sortOrder: 1 },
    { id: 'ent-gfx-02', name: 'Live Audio/Video & Scoreboard Templates', sortOrder: 2 },
    { id: 'ent-gfx-03', name: 'Building Shots & Media Sequence', sortOrder: 3 },
    { id: 'ent-gfx-04', name: 'Video Switcher & Data Controllers', sortOrder: 4 },
    { id: 'ent-gfx-05', name: 'Produce a Show', sortOrder: 5 },
];
// --- ScoreboardSIM Enterprise Lessons ---
exports.SCOREBOARD_ENTERPRISE_LESSON_IDS = [
    'ent-sb-01', 'ent-sb-02', 'ent-sb-03', 'ent-sb-04', 'ent-sb-05', 'ent-sb-06',
];
exports.SCOREBOARD_ENTERPRISE_LESSON_REGISTRY = [
    { id: 'ent-sb-01', name: 'MPCW-7 Controller Overview', sortOrder: 1 },
    { id: 'ent-sb-02', name: 'Setting the Clock & Period', sortOrder: 2, comingSoon: true },
    { id: 'ent-sb-03', name: 'Score Entry & Corrections', sortOrder: 3, comingSoon: true },
    { id: 'ent-sb-04', name: 'Possession & Timeouts', sortOrder: 4, comingSoon: true },
    { id: 'ent-sb-05', name: 'Sport-Specific Modes', sortOrder: 5, comingSoon: true },
    { id: 'ent-sb-06', name: 'Full Game Simulation', sortOrder: 6, comingSoon: true },
];
// --- Scoring Constants ---
exports.SCORING = {
    BASE_POINTS: 100,
    TOLERANCE_MS: 1000,
    PENALTY_PER_500MS: 15,
    MAX_PENALTY_PERCENT: 50,
    GRADE_THRESHOLDS: {
        A: 90,
        B: 80,
        C: 70,
        D: 60,
        F: 0,
    },
};
// --- Timing Constants ---
exports.TIMING = {
    EVENT_TRIGGER_TOLERANCE_MS: 110,
    TARGET_FPS: 30,
    COUNTDOWN_DELAY_MS: 4000,
    COUNTDOWN_PRE_MS: 500,
    CLOCK_SYNC_SAMPLES: 5,
};
// --- Room/Multiplayer Constants ---
exports.ROOM = {
    CODE_LENGTH: 6,
    MAX_PLAYERS: 10,
    CLEANUP_TIMEOUT_MS: 5 * 60 * 1000,
    RECONNECT_DELAY_MS: 2000,
    MAX_RECONNECT_ATTEMPTS: 5,
    PING_INTERVAL_MS: 30000,
};
// --- SwitcherSIM Connection ---
exports.SWITCHERSIM = {
    /** Production WebSocket URL (SwitcherSIM Heroku app) */
    WS_URL: 'wss://switchersim-v2-57fca08a5ed0.herokuapp.com/ws/game',
    /** Development WebSocket URL */
    WS_URL_DEV: 'ws://localhost:3001/ws/game',
    /** Production REST API base */
    API_URL: 'https://switchersim-v2-57fca08a5ed0.herokuapp.com/api/v1',
    /** Development REST API base */
    API_URL_DEV: 'http://localhost:3001/api/v1',
};
/** Default video URLs for SwitcherSIM inputs 1-8 (Azure blob storage fallback) */
exports.INPUT_URLS = {
    1: 'https://switchersimvids.blob.core.windows.net/vidstorage/L12_INPUT1.webm',
    2: 'https://switchersimvids.blob.core.windows.net/vidstorage/L12_INPUT2.webm',
    3: 'https://switchersimvids.blob.core.windows.net/vidstorage/L12_INPUT3.webm',
    4: 'https://switchersimvids.blob.core.windows.net/vidstorage/L12_INPUT4.webm',
    5: 'https://switchersimvids.blob.core.windows.net/vidstorage/L12_INPUT5.webm',
    6: 'https://switchersimvids.blob.core.windows.net/vidstorage/L12_INPUT6.webm',
    7: 'https://switchersimvids.blob.core.windows.net/vidstorage/L12_INPUT7.webm',
    8: 'https://switchersimvids.blob.core.windows.net/vidstorage/L12_INPUT8.webm',
};
// --- Server Ports ---
exports.PORTS = {
    GRAPHICS_SIM: 3000,
    SCOREBOARD_SIM: 3001,
    SERVER: 8080,
};
//# sourceMappingURL=index.js.map